import { useContext, useEffect, useState } from "react"
import { DContext } from "../../../../../context/Datacontext";
import { fetchSecondarySkills } from "../../../../services/Candidate/Profile/fetchCandidateDetails"
import { FiEdit2 } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";

function SecondarySkill({ candidate, currentUser, FaEye }) {

    const [secondarySkill, setSecondarySkill] = useState(null)
    const [viewSkills, setviewSkills] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerpage] = useState(5);
    const [totalPage, setTotalPage] = useState(0);
    const [totalSkill, setTotalSkill] = useState(0)
    const { BeURL, showAlert } = useContext(DContext)
    const navigate = useNavigate()
    const location = useLocation()


    useEffect(() => {
        const fetchSecondarySkill = async () =>
            await fetchSecondarySkills(BeURL, candidate._id, currentPage, rowsPerPage, setTotalSkill, setTotalPage, setSecondarySkill, showAlert)

        fetchSecondarySkill()
    }, [currentPage, rowsPerPage, BeURL])

   

    useEffect(() => {
        setCurrentPage(1)
    }, [rowsPerPage])


    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPage) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const openView = async (id) => {

        setviewSkills(secondarySkill.find(skill => skill._id === id))
    };
    return (
        <>
            {/* {
                Boolean(secondarySkill?.length) && */}
            <>
                <div className="flex justify-between items-center my-2 mt-10">
                    <h3 className="font-semibold text-lg md:text-xl ">Skills</h3>
                 <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/skills?inverse=${true}&candidateId=${candidate?._id}`, { state: { from: location.pathname, active: 'Skills' } })} />
                </div>
                <div className=" max-w-full overflow-x-auto ">
                    <div className="overflow-y-auto max-h-[400px]"> {/* Scroll if >15 rows */}
                        <table className="w-full  rounded-lg  border-separate border-spacing-y-2">
                            <thead className="bg-purple-100 text-secondary-300 sticky top-0 z-10">
                                <tr className="shadow shadow-blue-100 font-semibold ">
                                    <th className="p-2 rounded-l-lg">Skills/ Tools</th>
                                    <th className=" hidden md:table-cell p-2 ">Experiences</th>
                                    <th className="hidden md:table-cell p-2">Last Used</th>
                                    <th className=" p-2"><span className="hidden md:block">Version</span><span className="md:hidden">Action</span></th>
                                </tr>
                            </thead>
                            <tbody className=""> {/* adds spacing between rows */}
                                {(secondarySkill && secondarySkill?.length > 0) ? (secondarySkill.map((skill, i) => (
                                    <tr
                                        key={i}
                                        className="shadow shadow-blue-50 bg-white hover:bg-gray-50 transition text-center text-sm font-medium"
                                    >
                                        <td className="p-2 rounded-l-lg">{skill.skill.charAt(0).toUpperCase() + skill.skill.slice(1)}</td>
                                        <td className="p-2  hidden md:table-cell">
                                            {(skill?.experience &&
                                                Object.entries(skill?.experience).length > 0 &&
                                                (skill?.experience?.year || skill?.experience?.month)) ?
                                                `${skill.experience.year || 0} years, ${skill.experience.month || 0} months` : '-'}
                                        </td>
                                        <td className="p-2  hidden md:table-cell">{skill?.lastUsed || "NA"}</td>
                                        <td className="p-2 rounded-r-lg"> <span className="hidden md:block">{skill?.version || "NA"}</span><span className="md:hidden"> <button
                                            onClick={() => openView(skill._id)}
                                            className="text-slate-600 hover:text-slate-800"
                                            title="View"
                                        >
                                            <FaEye />
                                        </button>
                                        </span></td>
                                    </tr>
                                ))) : (<tr
                                    className="shadow shadow-blue-50 bg-white hover:bg-gray-50 transition text-center text-sm font-medium"
                                >
                                    <td colSpan={4} className="text-center p-2">No  Data Available!</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div>
                    <div className="mx-auto mt-7 flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-3">
                        <div className="flex items-center gap-2">
                            <label htmlFor="recordsPerPage" className="text-sm">
                                Records per page:
                            </label>
                            <select
                                id="recordsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => setRowsPerpage(parseInt(e.target.value, 10))}
                                className="ml-2 px-3 py-1 border rounded-lg text-sm"
                            >
                                {[5, 10, 25, 50, 75, 100].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex justify-center items-center gap-4 mt-4">
                            <span
                                className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === 1 ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                                    }`}
                                onClick={() => handlePagination("prev")}
                            >
                                chevron_left
                            </span>
                            <span className="text-sm md:text-base">
                                {currentPage} of {totalPage}
                            </span>
                            <span
                                className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === totalPage
                                    ? "cursor-not-allowed opacity-50"
                                    : "cursor-pointer"
                                    }`}
                                onClick={() => handlePagination("next")}
                            >
                                chevron_right
                            </span>
                        </div>
                        <div className="text-sm">Total Skills: {totalSkill}</div>
                    </div>

                </div>
            </>
            {/* } */}
            {
                viewSkills && (
                    <div className={`fixed inset-0 z-50 bg-black/30 ${viewSkills && 'flex'} md:hidden items-center justify-center `}>
                        <div className="bg-white p-6 rounded-lg max-w-sm w-full space-y-2">
                            <h3 className="text-xl font-semibold text-primary-400"> Skills</h3>
                            {["_id", "skill", "experience", "lastUsed", "version"].map((k) => (
                                <div key={k}>
                                    <span className="font-medium">
                                        {k === "_id" ? "ID" : k.at(0).toUpperCase() + k.slice(1).replace(/([A-Z])/g, " $1")}:
                                    </span>{" "}
                                    <span>
                                        {k === "_id" ? (
                                            viewSkills?._id
                                        ) : k === "experience" ? (
                                            viewSkills?.experience &&
                                                Object.keys(viewSkills.experience).length > 0 ? (
                                                `${viewSkills.experience.year || 0} years, ${viewSkills.experience.month || 0} months`
                                            ) : (
                                                "-"
                                            )
                                        ) : (
                                            viewSkills?.[k] || "-"
                                        )
                                        }
                                        
                                    </span>

                                </div>
                            ))}
                            <button
                                onClick={() => setviewSkills(null)}
                                className="mt-4 px-4 py-2 bg-primary-400 text-white rounded"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )
            }

        </>
    )
}

export default SecondarySkill